import { z } from 'zod';

export const DmStorageModeSchema = z.enum(['metadata', 'full']);

export const DmPreferenceSummarySchema = z.object({
  mode: DmStorageModeSchema,
  allowApiImport: z.boolean(),
  allowArchiveImport: z.boolean(),
  lastModeChangeAt: z.string().nullable(),
  updatedAt: z.string().nullable(),
  createdAt: z.string().nullable(),
});

export const DmSettingsStatsSchema = z.object({
  conversationCount: z.number(),
  interactionCount: z.number(),
  lastEventAt: z.string().nullable(),
  lastManualSyncAt: z.string().nullable(),
  lastArchiveImportAt: z.string().nullable(),
});

export const DmSettingsResponseSchema = z.object({
  preference: DmPreferenceSummarySchema,
  stats: DmSettingsStatsSchema,
});

export const DmSettingsUpdateSchema = z.object({
  mode: DmStorageModeSchema.optional(),
  allowApiImport: z.boolean().optional(),
  allowArchiveImport: z.boolean().optional(),
});

export const DmImportRequestSchema = z.object({
  maxPages: z.number().int().min(1).max(10).optional(),
  pageSize: z.number().int().min(10).max(100).optional(),
  paginationToken: z.string().optional(),
});

export const DmImportResponseSchema = z.object({
  imported: z.number(),
  nextToken: z.string().nullable(),
});

export type DmStorageMode = z.infer<typeof DmStorageModeSchema>;
export type DmPreferenceSummary = z.infer<typeof DmPreferenceSummarySchema>;
export type DmSettingsStats = z.infer<typeof DmSettingsStatsSchema>;
export type DmSettingsResponse = z.infer<typeof DmSettingsResponseSchema>;
export type DmSettingsUpdate = z.infer<typeof DmSettingsUpdateSchema>;
export type DmImportRequest = z.infer<typeof DmImportRequestSchema>;
export type DmImportResponse = z.infer<typeof DmImportResponseSchema>;
